import "./HomeMaintenance.module.css";
import Header from "@/reusable_sections/Header";
import HeroHomeMaintenance from "./sections/HeroHomeMaintenance";
import Services from "./sections/Services";
import PricingPackages from "./sections/PricingPackages";
import MaintenanceArticle from "./sections/MaintenanceArticle";
import Specialists from "./sections/Specialists";
import MaintenanceTestimonials from "./sections/MaintenanceTestimonials";
import MaintenanceFAQ from "./sections/MaintenanceFAQ";
import ReadyToSchedule from "./sections/ReadyToSchedule";
import Booking from "./sections/Booking";
import Footer from "@/reusable_sections/Footer";
export default function HomeMaintenancePage() {
  return <div>
      <Header />
      <HeroHomeMaintenance />
      <Services />
      <PricingPackages />
      <MaintenanceArticle />
      <Specialists />
      <MaintenanceTestimonials />
      <MaintenanceFAQ />
      <ReadyToSchedule />
      <Booking />
      <Footer />
    </div>;
}